import { value } from '@takeshape/util';
import { addAuthenticationFormConfig, addAuthenticationSchema, authenticationFormConfig, updateAuthentication } from "../util/authentication.js";
import { isCompleteGraphQLConfig } from "../util/config.js";
import { addHealthCheckFormConfig, addHealthCheckSchema, getHealthCheck, healthCheckFormConfig, updateHealthCheck } from "../util/health.js";
import { getInitialData } from "../util/initial-data.js";
const providerName = 'wordpress';
const defaultId = 'wordpress';
const title = 'WordPress';
const namespace = 'WP';
const serviceProvider = {
    name: providerName,
    title,
    description: 'WordPress is a popular open-source content management system (CMS) used for creating and managing websites, known for its user-friendly interface and wide range of themes and plugins.',
    categories: ['content'],
    links: [{ title: 'Homepage', url: 'https://wordpress.org/' }],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value(defaultId),
    getFormSchema: value(addAuthenticationSchema(addHealthCheckSchema({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9a-z_-]+',
                default: defaultId
            },
            title: {
                title: 'Name',
                type: 'string',
                default: title
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: namespace
            },
            endpoint: {
                title: 'Endpoint',
                type: 'string',
                pattern: '^https?:\\/\\/'
            }
        },
        required: ['title', 'id', 'namespace', 'endpoint']
    }, { checkNames: ['graphqlIntrospection', 'ping', 'none'] }))),
    getFormConfig: value(addHealthCheckFormConfig(addAuthenticationFormConfig({
        order: ['title', 'id', 'namespace', 'endpoint'],
        properties: {
            title: {
                widget: 'singleLineText'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'The human-readable unique identifier for this service.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your GraphQL API.'
            },
            endpoint: {
                widget: 'singleLineText',
                instructions: 'A WPGraphQL API endpoint'
            }
        }
    }))),
    getForms: value({
        ...healthCheckFormConfig,
        ...authenticationFormConfig
    }),
    getInitialData(serviceConfig) {
        const initialData = getInitialData(serviceProvider, serviceConfig);
        if (initialData.isNew) {
            initialData.healthCheck = {
                checkName: 'graphqlIntrospection'
            };
            initialData.authentication = {
                type: 'none'
            };
        }
        return initialData;
    },
    getConfig(formData) {
        const config = {
            title: formData.title ?? title,
            namespace: formData.namespace ?? namespace,
            provider: providerName,
            serviceType: 'graphql',
            authenticationType: 'none'
        };
        if (formData?.endpoint) {
            config.options = {
                endpoint: formData.endpoint
            };
        }
        return updateHealthCheck(updateAuthentication(config, formData), formData);
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
